import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from "rxjs";
import { FacilityService } from 'src/app/core/services/facility.service';
import { Subscription } from 'rxjs';
import { UtilizationFilter } from '../../services/stats.model';
import { StatsService } from '../../services/stats.service';
@Component({
  selector: 'app-equipment-usage',
  templateUrl: './equipment-usage.component.html',
  styleUrls: ['./equipment-usage.component.scss']
})
export class EquipmentUsage {
  editDateVisible: boolean;
  canEdit = false;
  private sub = new Subscription();
  filterData: UtilizationFilter[] = []
  dateFrom: Date;
  dateTo: Date;
  currentPath: string;
  hasInsigniaOnly = false;

  @Input() equipmentColorMap: any[];
  @Input() productMixData: any;
  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _facilityService: FacilityService,
    private _statsService: StatsService,
  ) {
  }

  ngOnInit() {
    const statsDateFilterSub = this._statsService.statsDateFilterSubscriber.subscribe(val => {
      this.dateFrom = val.dateFrom;
      this.dateTo = val.dateTo;
    })
    this.sub.add(statsDateFilterSub);

    const facilitySub = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.canEdit = res.summary.userRights.stats === 'F';
    });
    this.sub.add(facilitySub);

    this.canEdit = this._facilityService.selectedFacility().summary.userRights.stats === 'F';    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.productMixData && changes.productMixData.currentValue && changes.productMixData.currentValue !== changes.productMixData.previousValue) {
      this.hasInsigniaOnly = !!this.productMixData.productMix.find((val: any) => val.activityId === '10001');
      this.hasInsigniaOnly = this.hasInsigniaOnly && this.productMixData.productMix.filter((val: any) => val.activityId !== '10001').length === 0;
      if(this.hasInsigniaOnly) this.currentPath = 'averageByEquipment';
    }
  }

  navigateToChild(childPath: string) {
    this._router.navigate([childPath], { relativeTo: this._route });
  }

  onDateRangeChange($event: any) {
    if($event.dateTo && $event.dateFrom) {
      const dateFrom = new Date($event.dateFrom.year, $event.dateFrom.month - 1, $event.dateFrom.day);
      const dateTo = new Date($event.dateTo.year, $event.dateTo.month - 1, $event.dateTo.day);
      if (this.dateFrom.toDateString() !== dateFrom.toDateString() || this.dateTo.toDateString() !== dateTo.toDateString()) {
        this.dateFrom = new Date($event.dateFrom.year, $event.dateFrom.month - 1, $event.dateFrom.day);
        this.dateTo = new Date($event.dateTo.year, $event.dateTo.month - 1, $event.dateTo.day);
        this._statsService.updateStatsDateFilter({ dateFrom: this.dateFrom, dateTo: this.dateTo });
      }
    }
  
    this.editDateVisible = $event.visible;
  }

  filterChanged(e: UtilizationFilter[]) {
    this.filterData = e;
  }

  getFormat(date: string) {
    return 'MMM' + (new Date(date).getMonth() != 4 ? '. ': ' ') + 'dd, y';
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
